import React from "react";
import {
	FaFacebook,
	FaGithub,
	FaInstagram,
	FaLinkedin,
	FaTwitter,
} from "react-icons/fa";
import { SOCIAL_LINKS } from "../../constants";

const SocialIcons = React.memo(() => {
	const iconMap = {
		FaTwitter,
		FaFacebook,
		FaInstagram,
		FaGithub,
		FaLinkedin,
	};

	return (
		<div className='flex space-x-6'>
			{SOCIAL_LINKS.map((social) => {
				const IconComponent = iconMap[social.icon];
				return (
					<a
						key={social.name}
						href={social.href}
						target='_blank'
						rel='noopener noreferrer'
						className={`text-gray-700 ${social.hoverColor}`}
						aria-label={`Visit ${social.name} profile`}
					>
						<IconComponent size={24} />
					</a>
				);
			})}
		</div>
	);
});

SocialIcons.displayName = 'SocialIcons';

export default SocialIcons;
